import { render, staticRenderFns } from "../templates/dashboard.pug?vue&type=template&id=8062a9a2&scoped=true&lang=pug&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "../sass/dashboard.sass?vue&type=style&index=0&id=8062a9a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8062a9a2",
  null
  
)

export default component.exports